import { Skeleton } from "antd5";
import { Flex } from "styles/utility-components";

import { PinnedView } from "lib/hooks/api/notices/views/usePinnedViews";
import { SavedViewType } from "lib/types/savedViews";
import { useNoticeListsPageState } from "../useNoticeListsPageState";
import { NoViewHeaderText, ViewHeaderText } from "./ViewHeaderText";

const filteredAllViews = (allViews: SavedViewType[], pinnedViews: PinnedView[]) => {
  const pinnedView = pinnedViews.map((view) => allViews.find((v) => v.id === view.savedViewId));
  return pinnedView.filter((view) => view !== undefined) as SavedViewType[];
};

function ViewsContainer() {
  const { allViews, pinnedViews, selectedView, isLoadingViews } = useNoticeListsPageState();

  if (isLoadingViews) {
    return <Skeleton />;
  }

  if (!allViews || !pinnedViews) {
    return null;
  }

  return (
    <Flex column gap="16px">
      {selectedView ? (
        <ViewHeaderText view={selectedView} pinnedViews={filteredAllViews(allViews, pinnedViews)} />
      ) : (
        <NoViewHeaderText pinnedViews={filteredAllViews(allViews, pinnedViews)} />
      )}
    </Flex>
  );
}

export default ViewsContainer;
